// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__BEHfE","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__aTrn6"};